<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <div class="item-filter">
    <div class="lista">
      <div class="item" *ngFor="let periodo of periodosDisponiveis" (click)="onItemClick(periodo.id, $event)">
        <mat-radio-button
          color="primary"
          labelPosition="before"
          [value]="periodo.id"
          [checked]="isPeriodoSelecionado(periodo.id)"
          (change)="onPeriodoChange(periodo.id)"
        >
          <span class="filter-text">{{ periodo.text }}</span>
        </mat-radio-button>
      </div>
    </div>
  </div>
</div>
